<!--
    @name: 弹窗样式覆盖
    @description: 此组件覆盖el-dialog组件默认样式
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-12-09 12:19:04
-->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners">
    <div>
      <slot name="title"></slot>
    </div>
    <div>
      <slot></slot>
    </div>
    <div slot="footer">
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ui-dialog",
  inheritAttrs: false
}
</script>

<style scoped lang="scss">
/deep/.el-dialog{
  .el-dialog__header{
    padding: 0 20px;
    height: 54px;
    line-height: 54px;
    box-sizing: border-box;
    border-bottom: 1px solid var(--FCe);
  }
  .el-dialog__footer{
    padding: 0 20px 30px 20px;
    .el-button--default{
      &:hover{
        color: var(--Czsd);
        border-color: var(--Czsd);
        background: #fff;
      }
    }
    .el-button--primary{
      background: var(--Czsd);
      border-color: var(--Czsd);
      &:focus{
        opacity: 0.9;
      }
      &:hover{
        opacity: 0.9;
      }
    }
    .el-button+.el-button{
      margin-left: 20px;
    }
  }
}
</style>
